import { Alert } from "@mui/material";
import {
	BooleanField,
	DateField,
	DeleteButton,
	EditButton,
	NumberField,
	ReferenceField,
	Show,
	SimpleShowLayout,
	TextField,
	TopToolbar,
	useRecordContext,
} from "react-admin";
import { RestoreButton } from "@/components/RestoreButton";

const ReferralLinkShowActions = () => {
	const record = useRecordContext();

	return (
		<TopToolbar>
			<EditButton />
			{record?.deletedAt ? (
				<RestoreButton resource="referral-links" />
			) : (
				<DeleteButton />
			)}
		</TopToolbar>
	);
};

const DeletedAlert = () => {
	const record = useRecordContext();
	if (!record?.deletedAt) return null;

	return (
		<Alert severity="warning" sx={{ mb: 2 }}>
			This referral link was deleted on{" "}
			{new Date(record.deletedAt).toLocaleDateString()}.
		</Alert>
	);
};

export const ReferralLinkShow = () => (
	<Show actions={<ReferralLinkShowActions />}>
		<DeletedAlert />
		<SimpleShowLayout>
			<TextField source="id" />
			<TextField source="code" />
			<ReferenceField source="appId" reference="apps" link="show">
				<TextField source="name" />
			</ReferenceField>
			<ReferenceField source="partnerId" reference="partners" link="show">
				<TextField source="name" />
			</ReferenceField>
			<NumberField source="commissionPercent" label="Commission %" />
			<NumberField
				source="attributionWindowDays"
				label="Attribution Window (days)"
				emptyText="App default"
			/>
			<BooleanField source="active" />
			<DateField source="createdAt" label="Created" showTime />
			<DateField source="archivedAt" label="Archived" showTime emptyText="-" />
			<DateField source="deletedAt" label="Deleted" showTime emptyText="-" />
		</SimpleShowLayout>
	</Show>
);
